import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewSeoUrlsBlok } from '../../components/new_seo_urls_block';
import { SeoBlock } from '../../components/seo_block';
import { IStore } from '../../types/store';

const s = require('./seo_container.css');

export const SeoContainer = () => {
  const { seoText, seoTextHeading } = useSelector((state: IStore) => state.mainpage.seoData);
  const newSeoUrls = useSelector((state: IStore) => state.mainpage.newSeoUrls);

  if (!seoText.length && !seoTextHeading && !newSeoUrls.length) {
    return null;
  }

  return (
    <div className={s['c-seo']}>
      <div className="cg-container-fluid-xs">
        <div className="cg-row">
          {seoText.length > 0 && seoTextHeading && <SeoBlock seoText={seoText} seoTextHeading={seoTextHeading} />}
          {newSeoUrls.length > 0 && <NewSeoUrlsBlok newSeoUrls={newSeoUrls} />}
        </div>
      </div>
    </div>
  );
};
